"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacing = void 0;
// tslint:disable
exports.Spacing = {
    "spacing0x": "0",
    "spacing1x": ".5rem",
    "spacing2x": "1rem",
    "spacing3x": "1.5rem",
    "spacing4x": "2rem",
    "spacing5x": "2.5rem",
    "spacing6x": "3rem",
    "spacing7x": "3.5rem",
    "spacing8x": "4rem",
    "spacing9x": "4.5rem",
    "spacing10x": "5rem",
};
// tslint:enable
